/**
 * Pre-order with Gifts Functionality
 * Handles gift selection and adding both main product and gifts to cart
 */

(function () {
  "use strict";

  // Store selected gifts globally
  window.boSelectedGifts = window.boSelectedGifts || [];

  /**
   * Open gift modal and configure for current variant
   */
  function openGiftModal(variantCard) {
    const modal = document.getElementById("boGiftModal");
    if (!modal) return;

    const giftType = variantCard.getAttribute("data-gift-type");
    const giftCount = parseInt(variantCard.getAttribute("data-gift-count"));

    // Reset modal
    window.boSelectedGifts = [];
    document.querySelectorAll(".bo-gift-item").forEach((item) => {
      item.classList.remove("selected");
    });

    // Configure modal based on gift requirements
    if (giftType === "chillplaid") {
      // Show only Chill Plaid section
      document.querySelectorAll(".bo-gift-section").forEach((section) => {
        if (section.getAttribute("data-gift-section") === "chillplaid") {
          section.style.display = "block";
        } else {
          section.style.display = "none";
        }
      });
    } else if (giftType === "beautypouch") {
      // Show only Beauty Pouch section
      document.querySelectorAll(".bo-gift-section").forEach((section) => {
        if (section.getAttribute("data-gift-section") === "beautypouch") {
          section.style.display = "block";
        } else {
          section.style.display = "none";
        }
      });
    } else if (giftType === "both") {
      // Show both sections
      document.querySelectorAll(".bo-gift-section").forEach((section) => {
        section.style.display = "block";
      });
    }

    // Update gift count in title
    const countSpan = document.querySelector(".bo-gift-count");
    if (countSpan) {
      countSpan.textContent = giftCount;
    }

    // Show modal
    modal.classList.add("active");
    document.body.style.overflow = "hidden";

    // Store current requirement
    modal.setAttribute("data-required-count", giftCount);
    modal.setAttribute("data-gift-type", giftType);
  }

  /**
   * Close gift modal
   */
  function closeGiftModal() {
    const modal = document.getElementById("boGiftModal");
    if (!modal) return;

    modal.classList.remove("active");
    document.body.style.overflow = "";

    // Clear selections
    resetGiftSelections();
  }

  /**
   * Reset gift selections in modal
   */
  function resetGiftSelections() {
    window.boSelectedGifts = [];
    document.querySelectorAll(".bo-gift-item").forEach((item) => {
      item.classList.remove("selected");
    });
  }

  /**
   * Add product to cart via AJAX
   */
  function addToCart(items) {
    return fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ items: items }),
    }).then((response) => response.json());
  }

  /**
   * Handle pre-order form submission
   */
  function handlePreorderSubmit(e) {
    const form = e.target;
    const formData = new FormData(form);
    const variantId = formData.get("id");
    const quantity = parseInt(formData.get("quantity")) || 1;

    // Check if gifts are required and selected
    const selectedVariantCard = document
      .querySelector(".bo-variant-radio:checked")
      ?.closest(".bo-variant-card");
    if (!selectedVariantCard) {
      alert("Veuillez sélectionner une variante");
      return;
    }

    const giftCount = parseInt(
      selectedVariantCard.getAttribute("data-gift-count")
    );

    if (giftCount > 0 && window.boSelectedGifts.length < giftCount) {
      e.preventDefault();
      alert("Veuillez sélectionner vos cadeaux avant de pré-commander");
      // Open gift modal
      const giftBtn = selectedVariantCard.querySelector(".bo-choose-gift-btn");
      if (giftBtn) {
        giftBtn.click();
      }
      return;
    }

    // Prevent default form submission
    e.preventDefault();

    // Prepare items to add to cart
    const items = [];

    // Calculate expected ship date (3 weeks from now as per lead time)
    const expectedDate = new Date();
    expectedDate.setDate(expectedDate.getDate() + 21); // 3 weeks minimum
    const expectedShipDate = expectedDate.toLocaleDateString("fr-FR", {
      day: "numeric",
      month: "long",
      year: "numeric",
    });

    // Add main pre-order product with proper properties
    const mainProperties = {
      _preorder: "true",
      _gift_count: giftCount.toString(), // For Shopify Script validation
      _expected_ship_date: expectedShipDate,
      _fulfillment_group: "PREORDER",
      "Livraison estimée": expectedShipDate,
    };

    // Add gift summary to main product properties
    if (window.boSelectedGifts.length > 0) {
      mainProperties["Cadeaux inclus"] = window.boSelectedGifts
        .map((g) => `${g.title} - ${g.variant}`)
        .join("; ");
    }

    items.push({
      id: variantId,
      quantity: quantity,
      properties: mainProperties,
    });

    // Add gift items - Shopify Script will discount these to $0
    window.boSelectedGifts.forEach((gift) => {
      items.push({
        id: parseInt(gift.variantId),
        quantity: 1,
        properties: {
          _is_gift: "true", // Shopify Script checks for this
          _gift_with_preorder: variantId.toString(),
          _fulfillment_group: "IMMEDIATE",
          Type: "Cadeau gratuit",
          Livraison: "Immédiate (48h)",
        },
      });
    });

    // Show loading state
    const submitBtn = form.querySelector(".bo-preorder-btn");
    const originalText = submitBtn.innerHTML;
    submitBtn.disabled = true;
    submitBtn.innerHTML = "<span>Ajout au panier...</span>";

    // Add all items to cart
    addToCart(items)
      .then((data) => {
        // Show success message
        submitBtn.innerHTML = "<span>✓ Ajouté au panier!</span>";

        // Set cart attribute to indicate pre-order items are present
        return fetch(window.Shopify.routes.root + "cart/update.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            attributes: {
              _has_preorder: "true",
            },
          }),
        });
      })
      .then(() => {
        // Wait for Shopify to fully process the cart update
        // We need to poll the cart to ensure it has the new items before triggering the drawer
        const pollCart = (attempts = 0, maxAttempts = 10) => {
          if (attempts >= maxAttempts) {
            console.error("Cart polling timeout - triggering event anyway");
            jQuery("body").trigger("added.ajaxProduct");
            return;
          }

          fetch(window.Shopify.routes.root + "cart.js")
            .then((response) => response.json())
            .then((cart) => {
              // Check if cart has been updated with our items
              if (cart.item_count >= items.length) {
                // Reload page to display updated cart
                window.location.reload();
              } else {
                // Cart not ready yet, poll again
                setTimeout(() => pollCart(attempts + 1, maxAttempts), 200);
              }
            })
            .catch((err) => {
              console.error("Error polling cart:", err);
              setTimeout(() => pollCart(attempts + 1, maxAttempts), 200);
            });
        };

        // Start polling after a short delay
        setTimeout(() => pollCart(), 300);

        // Reset button after 2 seconds
        setTimeout(() => {
          submitBtn.innerHTML = originalText;
          submitBtn.disabled = false;
        }, 2000);
      })
      .catch((error) => {
        console.error("Error adding to cart:", error);
        alert("Une erreur s'est produite. Veuillez réessayer.");
        submitBtn.disabled = false;
        submitBtn.innerHTML = originalText;
      });
  }

  /**
   * Update variant card active state
   */
  function updateVariantCardState() {
    const variantCards = document.querySelectorAll(".bo-variant-card");

    variantCards.forEach((card) => {
      const radio = card.querySelector(".bo-variant-radio");

      if (radio) {
        radio.addEventListener("change", function () {
          // Remove checked-item from all cards
          variantCards.forEach((c) => c.classList.remove("checked-item"));

          // Add checked-item to selected card
          if (this.checked) {
            card.classList.add("checked-item");
          }

          // Reset gift selection when changing variants
          window.boSelectedGifts = [];
          const giftBtn = card.querySelector(".bo-choose-gift-btn");
          if (giftBtn) {
            const indicator = giftBtn.querySelector(
              ".bo-gift-selected-indicator"
            );
            if (indicator) {
              indicator.style.display = "none";
            }
            giftBtn.querySelector(".bo-gift-btn-text").textContent =
              giftBtn
                .querySelector(".bo-gift-btn-text")
                .getAttribute("data-original-text") || "Choisir mon cadeau";
          }
        });
      }
    });
  }

  /**
   * Move variant cards into placement wrapper (filtered by selected options)
   */
  function moveVariantsToWrapper() {
    const wrapper = document.querySelector(".custom-variant-placement-wrapper");
    const templateData = document.querySelector(".varaint-template-data");

    if (!wrapper || !templateData) return;

    // Get selected size option
    const sizeInput = document.querySelector(
      '.bo-preorder-wrapper .custom-swatch:not([data-last="true"]) input[type="radio"]:checked'
    );
    const selectedSize = sizeInput ? sizeInput.value : null;

    // Clear wrapper
    wrapper.innerHTML = "";

    // Get all variant cards and filter by selected size
    const variantCards = templateData.querySelectorAll(".bo-variant-card");
    variantCards.forEach((card) => {
      const variantOptions = card.getAttribute("data-option");
      if (variantOptions && selectedSize) {
        // Check if this variant matches the selected size
        if (
          variantOptions.startsWith(selectedSize + "-") ||
          variantOptions === selectedSize
        ) {
          wrapper.appendChild(card.cloneNode(true));
        }
      } else if (!selectedSize) {
        // If no size selected, show first 3 variants
        if (Array.from(wrapper.children).length < 3) {
          wrapper.appendChild(card.cloneNode(true));
        }
      }
    });

    // Re-attach event listeners
    updateVariantCardState();
  }

  /**
   * Initialize on DOM ready
   */
  function init() {
    // Move variant cards to visible wrapper
    moveVariantsToWrapper();

    const preorderBtn = document.querySelector(".bo-preorder-btn");

    if (preorderBtn) {
      preorderBtn.addEventListener("click", function (e) {
        e.preventDefault();
        const form = preorderBtn.closest("form");
        if (form) {
          handlePreorderSubmit({ target: form, preventDefault: () => {} });
        }
      });
    }

    updateVariantCardState();

    // Store original button text
    const giftBtns = document.querySelectorAll(
      ".bo-choose-gift-btn .bo-gift-btn-text"
    );
    giftBtns.forEach((btn) => {
      btn.setAttribute("data-original-text", btn.textContent);
    });

    // Listen for size option changes
    const sizeInputs = document.querySelectorAll(
      '.bo-preorder-wrapper .custom-swatch:not([data-last="true"]) input[type="radio"]'
    );
    sizeInputs.forEach((input) => {
      input.addEventListener("change", moveVariantsToWrapper);
    });

    // Note: Gift modal handlers are in bo-gift-selection-modal.liquid
    // to avoid conflicts with duplicate event listeners
  }

  // Initialize when DOM is ready
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
